import React from "react";
import { Card, Divider, Typography, Form, Spin, List, Select, Button, Row, Col, DatePicker } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./index.scss";

const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

interface ReconciliationFilterProps {
  filterForm: any;
  loadingDropdown: boolean;
  reconciliationFilterValues: {
    lenders: { key: string; value: string }[];
    loanProducts: { key: string; value: string }[];
  };
  onApplyFilter: (values: any) => void;
  onClose: () => void;
  selectedTab: string;
}

const ReconciliationFilter: React.FC<ReconciliationFilterProps> = ({
  filterForm,
  loadingDropdown,
  reconciliationFilterValues,
  onApplyFilter,
  onClose,
  selectedTab,
}) => {
  return (
    <Card className="filter-card">
      <Title level={5} className="filter-header">
        <Row>
          <Col span={12}>Filter</Col>
          <Col span={12} className="flex-end">
            <CloseOutlined onClick={onClose} />
          </Col>
        </Row>
      </Title>
      <Divider />
      
      <Form
        form={filterForm}
        layout="vertical"
        onFinish={onApplyFilter}
        autoComplete="off"
      >
        <Spin spinning={loadingDropdown}>
          <div className="filter-container">
            <List
              className="filter-list"
              grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
              dataSource={[
                <List.Item key="PRODUCT">
                  <Form.Item label="Product" name="product">
                    <Select 
                      placeholder="Product" 
                      allowClear 
                      className="custom-select"
                      showSearch
                      optionFilterProp="children"
                    >
                      {reconciliationFilterValues.loanProducts?.map(
                        (item) => (
                          <Option key={item.key} value={item.key}>
                            {item.value}
                          </Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </List.Item>,
                <List.Item key="LENDER">
                  <Form.Item label="Lender Name" name="lenderName">
                    <Select 
                      placeholder="Lender Name" 
                      allowClear 
                      className="custom-select"
                      showSearch
                      optionFilterProp="children"
                    >
                      {reconciliationFilterValues.lenders?.map(
                        (lender) => (
                          <Option key={lender.key} value={lender.key}>
                            {lender.value}
                          </Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </List.Item>,
                <List.Item key="DISBURSED_DATE">
                  <Form.Item label="Disbursed Date" name="disbursedDate">
                    <RangePicker
                      className="custom-input"
                      placeholder={["Disbursed From Date", "Disbursed To Date"]}
                      format="DD-MM-YYYY"
                    />
                  </Form.Item>
                </List.Item>,
                (selectedTab === "RECONCILED" || selectedTab === "DISCREPANCIES" || selectedTab === "ADJUSTED_DISCREPANCIES") && (
                  <List.Item key="LENDER_DISBURSED_DATE">
                    <Form.Item label="Lender Disbursed Date" name="lenderDisbursedDate">
                      <RangePicker
                        className="custom-input"
                        placeholder={["Lender Disbursed From Date", "Lender Disbursed To Date"]}
                        format="DD-MM-YYYY"
                      />
                    </Form.Item>
                  </List.Item>
                ),
              ].filter(Boolean)}
              renderItem={(item) => item}
            />
          </div>
          
          <Divider />
          
          <div className="filter-buttons-container">
            <Button
              size="large"
              htmlType="button"
              onClick={() => {
                filterForm.resetFields();
                // clear filters and refresh table
                onApplyFilter({});
              }}
            >
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={loadingDropdown}
            >
              Apply Filter
            </Button>
          </div>
        </Spin>
      </Form>
    </Card>
  );
};

export default ReconciliationFilter;
